module.exports = __webpack_public_path__ + "static/media/Pinterest.3cba3b5c.svg";